module.exports = __webpack_public_path__ + "static/img/logo.a6d746fa.svg";